export default __webpack_public_path__ + "static/media/Support_Bg-Loop.83e45e55.mp4";